export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "auth.worker.ddd29d09634854eb28c0.worker.js");
}
